const GLOBAL_LIGHT_CONFIG = {
  ambient: {
    enabled: true,
    color: 0xffffff, // 0xFFEFE4
    intensity: 1.5,
  },
}

export { GLOBAL_LIGHT_CONFIG };
